import { ConsultationRequestError } from '@errors/consultation-request-error';

export class ConsultationRequestActiveScheduledError extends ConsultationRequestError {
  public constructor(phoneNumber: string) {
    super(
      'There is already an active Consultation Request in our system. If you would like to reschedule or cancel, ' +
        `please follow the link in the previous consultation confirmation email or call Patient Services at ${phoneNumber}.`,
    );
  }
}
